export const OFFER_CREATE_REQUEST = "OFFER_CREATE_REQUEST";
export const OFFER_CREATE_SUCCESS = "OFFER_CREATE_SUCCESS";
export const OFFER_CREATE_FAIL = "OFFER_CREATE_FAIL";
export const OFFER_CREATE_RESET = "OFFER_CREATE_RESET";

export const OFFER_LIST_REQUEST = "OFFER_LIST_REQUEST";
export const OFFER_LIST_SUCCESS = "OFFER_LIST_SUCCESS";
export const OFFER_LIST_FAIL = "OFFER_LIST_FAIL";

export const OFFER_UPDATE_REQUEST = "OFFER_UPDATE_REQUEST";
export const OFFER_UPDATE_SUCCESS = "OFFER_UPDATE_SUCCESS";
export const OFFER_UPDATE_FAIL = "OFFER_UPDATE_FAIL";
export const OFFER_UPDATE_RESET = "OFFER_UPDATE_RESET";

export const OFFER_DELETE_REQUEST = "OFFER_DELETE_REQUEST";
export const OFFER_DELETE_SUCCESS = "OFFER_DELETE_SUCCESS";
export const OFFER_DELETE_FAIL = "OFFER_DELETE_FAIL";
export const OFFER_DELETE_RESET = "OFFER_DELETE_RESET";

export const OFFER_VALIDATE_REQUEST = "OFFER_VALIDATE_REQUEST";
export const OFFER_VALIDATE_SUCCESS = "OFFER_VALIDATE_SUCCESS";
export const OFFER_VALIDATE_FAIL = "OFFER_VALIDATE_FAIL";
export const OFFER_VALIDATE_RESET = "OFFER_VALIDATE_RESET";
